"use client";

import { BSRTrashCan } from "./bsr/BSRTrashCan";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { TrashCan as LegacyTrashCan } from "./legacy/TrashCan";

export const TrashCan = createBSRExperimentIcon(LegacyTrashCan, BSRTrashCan);
